import api from './api';

export interface StudentDto {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: string;
  createdAt: string;
}

const extractArrayFromPayload = <T>(payload: unknown, keys: string[]): T[] => {
  if (Array.isArray(payload)) {
    return payload as T[];
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const asRecord = payload as Record<string, unknown>;
  for (const key of keys) {
    const value = asRecord[key];
    if (Array.isArray(value)) {
      return value as T[];
    }
  }

  const data = asRecord.data;
  if (Array.isArray(data)) {
    return data as T[];
  }

  return [];
};

export const studentsService = {
  async getStudents(): Promise<StudentDto[]> {
    const response = await api.get('/students');
    return extractArrayFromPayload<StudentDto>(response.data, ['students', 'items']);
  },

  async getStudentsByTenant(tenantId: string): Promise<StudentDto[]> {
    const response = await api.get(`/students/tenant/${tenantId}`);
    return extractArrayFromPayload<StudentDto>(response.data, ['students', 'items']);
  },

  async getCurrentStudent(): Promise<StudentDto> {
    const response = await api.get<StudentDto>('/students/me');
    return response.data;
  },
};


